module.exports = "/static/media/noFee.7447643e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/noFee.png
// module id = 806
// module chunks = 0